import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import TableComponent from 'UiKit/table-component';
import { TextMedium } from 'UiKit/typography';
import mappedPromotionProduct from 'View/host-stock-promo/helper/mappedPromotionProduct';

import getTableList from './const';

import styles from './styles.module.css';

const ListPromoDetail = ({ data }) => {
  const { t } = useTranslation('host-stock-promo');
  const columns = getTableList(t);
  const dataSource = mappedPromotionProduct(data);
  return (
    <Box className={styles['list-promo-detail__container']} data-testid="list-promo-detail">
      <TextMedium className={styles['list-promo-detail__title']}>{t('promo_detail.product')}</TextMedium>
      <Box className={styles['list-promo-detail__box--table']}>
        <TableComponent
          columns={columns}
          dataSource={dataSource}
          isDataExist={true}
          containerClassName={styles['list-promo-detail__table--container']}
          rowHeight="82px"
          rowMaxHeight="100px"
          headRowHeight="38px"
        />
      </Box>
    </Box>
  );
};

export default ListPromoDetail;
